import axios from 'axios';
import router from './router';
import store from './store';
import { message } from 'ant-design-vue';

const hostname = window.location.host;

const subdomain = hostname.split('.')[0];

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Subdomain': subdomain
  },
});

let activeRequests = 0;
let errorMessageShown = false;

const showLoader = () => {
  if (activeRequests === 0) {
    store.dispatch('showLoader');
  }
  activeRequests++;
};

const hideLoader = () => {
  if(activeRequests <= 0){
    activeRequests = 1
  }
  activeRequests--;
  if (activeRequests === 0) {
    store.dispatch('hideLoader');
  }
};

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    // Skip global loader if skipGlobalLoader flag is set
    if (!config.skipGlobalLoader) {
      showLoader();
    }
  } else {
    if(config?.url === '/forgot-password'){
      router.push('/forgot-password');
    } else{
      router.push('/'); // Redirect to login page if token is missing
    }
  }
  
  return config;
}, error => {
  hideLoader();
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  response => {
    // Only hide loader if it wasn't skipped in the request
    if (!response.config.skipGlobalLoader) {
      hideLoader();
    }
    return response;
  },
  async error => {
    // Only hide loader if it wasn't skipped in the request
    if (!error.config?.skipGlobalLoader) {
      hideLoader();
    }
    if (error.response && (error.response.status === 401 || error.response.status === 403) && localStorage.getItem('authToken')) {
      if (!errorMessageShown) {
        errorMessageShown = true;
        message.error("Session expired. Please log in again");
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        router.push('/'); // Redirect to the login page
      }
    }
    return Promise.reject(error);
  }
);

// Reset error message flag when a new API call starts
apiClient.interceptors.request.use(config => {
  errorMessageShown = false;
  return config;
});

export default apiClient;
